if (!customElements.get('localization-form')) {

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        languageCode: this.querySelector('input[name="language_code"]'),
        countryCode: this.querySelector('input[name="country_code"]'),
        button: this.querySelector('[data-toggle-disclosure]'),
        panel: this.querySelector('[data-disclosure-panel]'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('[data-language], [data-county]').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      if (!form) return false;
      if (event.currentTarget.dataset.language) {
        this.elements.languageCode.value = event.currentTarget.dataset.language;
      }
      if (event.currentTarget.dataset.country) {
        this.elements.countryCode.value = event.currentTarget.dataset.country;
      }
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);
  window.LocalizationForm = LocalizationForm;
}
